export default __webpack_public_path__ + "static/media/selfies.0d7f8497.svg";